import { DashboardIconHourGlass } from '@hr/common/icons'
import { useEffect, useState } from 'react'
import { Table } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { getAllPersons } from '../../actions/persons/personsgetall'
import { LoadingContainer } from '../../common/loaders/loadingcontainer'
import { jsError, localized } from '../../common/utils'
import { personsSelector } from '../../reducers'

export function EndingTrialPeriods() {
	const { t } = useTranslation()
	const dispatch = useDispatch()
	const persons = useSelector(personsSelector)

	const startKey = 'endingTrialPeriods_startDate'
	const endKey = 'endingTrialPeriods_endDate'
	const todayStr = new Date().toISOString().split('T')[0]

	const [startDate, setStartDate] = useState(() => {
		return (
			localStorage.getItem(startKey) ||
			new Date(Date.UTC(new Date().getFullYear(), new Date().getMonth(), 1)).toISOString().split('T')[0]
		)
	})

	const [endDate, setEndDate] = useState(() => {
		return (
			localStorage.getItem(endKey) ||
			new Date(Date.UTC(new Date().getFullYear(), new Date().getMonth() + 1, 0)).toISOString().split('T')[0]
		)
	})

	const [data, setData] = useState()

	useEffect(() => {
		const fetchPersons = async () => {
			try {
				dispatch(getAllPersons())
			} catch (err) {
				jsError(err)
			}
		}
		fetchPersons()
	}, [dispatch])

	useEffect(() => {
		if (persons) {
			const start = new Date(startDate)
			start.setHours(0, 0, 0, 0)

			const end = new Date(endDate)
			end.setHours(23, 59, 59, 999)

			const filteredPersons = persons.filter((person) => {
				if (person.employmentDetails) {
					const { trialPeriod, trialPeriodEndDate, endDate: employmentEndDate } = person.employmentDetails

					if (!trialPeriodEndDate) return false

					const trialEnd = new Date(trialPeriodEndDate)

					return (
						trialPeriod === true &&
						trialEnd >= start &&
						trialEnd <= end &&
						(!employmentEndDate || new Date(employmentEndDate) >= new Date())
					)
				}
				return false
			})

			filteredPersons.sort((a, b) => {
				return (
					new Date(a.employmentDetails.trialPeriodEndDate).getTime() -
					new Date(b.employmentDetails.trialPeriodEndDate).getTime()
				)
			})

			const tableData = filteredPersons.map((person) => ({
				personName: person.name,
				profession: person.employmentDetails.profession,
				trialPeriodEndDate: person.employmentDetails.trialPeriodEndDate,
			}))

			setData(tableData)
		}
	}, [persons, startDate, endDate])

	const handleStartDateChange = (val) => {
		setStartDate(val)
		localStorage.setItem(startKey, val)
	}

	const handleEndDateChange = (val) => {
		setEndDate(val)
		localStorage.setItem(endKey, val)
	}

	if (!data) {
		return <LoadingContainer />
	}

	return (
		<>
			<div
				style={{
					display: 'flex',
					justifyContent: 'space-between',
					alignItems: 'center',
				}}
			>
				<div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
					<span className="starting-employments-icon">
						<DashboardIconHourGlass />
					</span>
					<h4 style={{ margin: 0 }}>{t('EndingTrialPeriods', 'Päättyvät koeajat')}</h4>
				</div>

				<div style={{ display: 'flex', gap: '10px' }}>
					<input type="date" value={startDate} onChange={(e) => handleStartDateChange(e.target.value)} />

					<input type="date" value={endDate} onChange={(e) => handleEndDateChange(e.target.value)} />
				</div>
			</div>

			{data.length ? (
				<div style={{ overflowX: 'auto' }}>
					<Table>
						<thead>
							<tr>
								<th>{t('Person', 'Henkilö')}</th>
								<th>{t('JobTitle', 'Tehtävänimike')}</th>
								<th>{t('Ending', 'Päättyy')}</th>
							</tr>
						</thead>
						<tbody>
							{data.map((row) => (
								<tr key={row.personName}>
									<td>{row.personName}</td>
									<td>{row.profession}</td>
									<td>
										{row.trialPeriodEndDate
											? new Date(row.trialPeriodEndDate).toLocaleDateString(localized.resolvedLanguage)
											: '-'}
									</td>
								</tr>
							))}
						</tbody>
					</Table>
				</div>
			) : (
				<p>({t('NoEndingTrials', 'Ei päättyviä koeaikoja valitulla aikavälillä')})</p>
			)}
		</>
	)
}
